export default __webpack_public_path__ + "static/media/verified.1d85033e.svg";